import { useEffect, useState } from 'react'
import type { RefObject } from 'react'

interface UseIsVisibleParams {
  ref: RefObject<any>
  buffer?: string
  once?: boolean
  enabled?: boolean
}

function useIsVisible({
  ref,
  buffer = '200px 0px',
  once = false,
  enabled = true,
}: UseIsVisibleParams): boolean {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!enabled) {
      return
    }
    if (!ref.current) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
        if (once && entry.isIntersecting) {
          observer.unobserve(entry.target)
        }
      },
      {
        rootMargin: buffer,
      },
    )
    observer.observe(ref.current)
  }, [buffer, once, ref, ref.current, enabled])

  return isVisible
}

export default useIsVisible
